'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = exports.YouTubeVideoModalUnwrapped = exports.modalConfig = exports.configString = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  autoplay: 1,
  color: 'white',
  disablekb: 1,
  modestbranding: 1,
  showinfo: 0,
  rel: 0
};

var configString = exports.configString = (0, _keys2.default)(config).map(function (key) {
  return key + '=' + config[key];
}).join('&');

var modalConfig = exports.modalConfig = {
  backdropClass: 'videos__overlay--fullscreen__backdrop',
  modalBorderClass: 'modal__border modal__border--video',
  centerVertically: true,
  headerClass: 'modal--colorful videos__overlay--fullscreen',
  lightClose: true,
  frameBorder: 0,
  modalContentClass: 'modal__content--video'
};

var YouTubeVideoModalUnwrapped = exports.YouTubeVideoModalUnwrapped = function YouTubeVideoModalUnwrapped(_ref) {
  var videoId = _ref.videoId;

  var src = 'https://www.youtube.com/embed/' + videoId + '?' + configString;

  return _react2.default.createElement('iframe', {
    allowFullScreen: true,
    className: 'modal__video',
    frameBorder: 0,
    scrolling: 'no',
    src: src
  });
};

YouTubeVideoModalUnwrapped.propTypes = {
  videoId: _propTypes2.default.string.isRequired
};

var Modal = exports.Modal = (0, _Modal2.default)(modalConfig)(YouTubeVideoModalUnwrapped);